var cibDeviantart = ["32 32", "<path d='M25.609 6.391l0.308-0.573v-5.817h-5.824l-0.583 0.588-2.745 5.229-0.859 0.584h-9.803v7.989h5.391l0.479 0.583-5.567 10.641-0.319 0.573v5.812h5.819l0.583-0.588 2.761-5.229 0.853-0.584h9.803v-7.989h-5.401l-0.479-0.583 5.583-10.641z'/>"];

export { cibDeviantart };

